import { render, staticRenderFns } from "./currency-changer.vue?vue&type=template&id=5a9e1868&scoped=true&"
import script from "./currency-changer.vue?vue&type=script&lang=js&"
export * from "./currency-changer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9e1868",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a9e1868')) {
      api.createRecord('5a9e1868', component.options)
    } else {
      api.reload('5a9e1868', component.options)
    }
    module.hot.accept("./currency-changer.vue?vue&type=template&id=5a9e1868&scoped=true&", function () {
      api.rerender('5a9e1868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/mixins/currency-changer.vue"
export default component.exports